"use client";

import { PORTALS } from ".constants/portals";
import {
  PortalModal,
  ModalHeader,
  ModalContent,
  Textarea,
  Button,
} from "@cloai/uikit";
import { useTranslations } from "next-intl";
import { memo } from "react";

import { useFeedbackPortal } from "./useFeedbackPortal";

export const FeedBackPortal = memo(() => {
  const t = useTranslations("FeedBackModal");
  const { feedback, loading, onClose, onFeedBackChange, onSendFeedBack } =
    useFeedbackPortal();

  return (
    <PortalModal
      portalId={PORTALS.FEEDBACK}
      repositionInputs={false}
      onClose={onClose}
    >
      <ModalHeader className="text-balance">{t("title")}</ModalHeader>

      <ModalContent>
        <Textarea value={feedback} onChange={onFeedBackChange} />

        <Button
          color="primary"
          wide
          centerText
          onClick={onSendFeedBack}
          loading={loading}
          disabled={!feedback}
        >
          {t("buttonText")}
        </Button>
      </ModalContent>
    </PortalModal>
  );
});

FeedBackPortal.displayName = "FeedBackPortal";
